import React from 'react';
import "../../../center admin css/centerAdmin.css"

type InfoItemProps = {
	icon?: React.ReactNode; //
	label: string;
	value?: string;
	
};

const InfoItem: React.FC<InfoItemProps> = ({ icon, label, value }) => {
	return (
		<div className="info-item">
			<div className="info-item__icon">{icon}</div>
			<div className="info-item__content">
				<div className="info-item__label">{label}</div>
				{value && <div className="info-item__value">{value}</div>}
			</div>
		</div>
	);
};

export default InfoItem;


